import { useState } from 'react'
import { Alert, Container } from '@mui/material'

import { startSession } from '../core/api/client'
import LandingCard from '../components/landing/LandingCard'
import AppFooter from '../components/layout/AppFooter'
import AppHeader from '../components/layout/AppHeader'
import Shell from '../components/layout/Shell'
import Questionnaire from '../components/questionnaire/Questionnaire'

export default function DiagnosisPage() {
  const [question, setQuestion] = useState(null)
  const [sessionToken, setSessionToken] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  function returnToLanding() {
    setSessionToken('')
    setQuestion(null)
    setError('')
  }

  async function begin() {
    setLoading(true)
    setError('')

    try {
      const response = await startSession()
      setSessionToken(response.sessionToken)
      setQuestion(response.nextQuestion)
    } catch (caught) {
      setError(caught.message)
    } finally {
      setLoading(false)
    }
  }

  if (!sessionToken) {
    return <LandingCard onStart={begin} loading={loading} error={error} />
  }

  return (
    <Shell>
      <AppHeader />
      {error ? (
        <Container maxWidth="lg" sx={{ pt: 2 }}>
          <Alert severity="error" onClose={() => setError('')}>
            {error}
          </Alert>
        </Container>
      ) : null}
      <Questionnaire
        sessionToken={sessionToken}
        question={question}
        setQuestion={setQuestion}
        setError={setError}
        onReturnHome={returnToLanding}
      />
      <AppFooter />
    </Shell>
  )
}
